module.exports = __webpack_public_path__ + "img/chat.90b27839.png";